import { render, staticRenderFns } from "./BackupsSettings.vue?vue&type=template&id=b9d07b46&"
import script from "./BackupsSettings.vue?vue&type=script&lang=js&"
export * from "./BackupsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports